import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { CardActions, Grid } from '@material-ui/core';
import { getType } from 'typesafe-actions';
import * as Styles from '../../../common/styles/styles';
import {
  forgotPasswordInit,
  forgotPasswordValidationSchema,
} from './forgotPassword.dtos';
import { forgotPasswordActions } from './forgotPassword.actions';
import { Button, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { CenterAlign } from '../../../common/components/layout';
import { ResponsiveCard } from '../../../common/components/cards';

const ForgotPassword: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const onCancel = () => history.push('/login');

  return (
    <CenterAlign>
      <ResponsiveCard>
        <Formik
          initialValues={forgotPasswordInit}
          validateOnChange={false}
          validationSchema={forgotPasswordValidationSchema}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              setSubmitting(false);
            }, 700);
            dispatch({
              type: getType(forgotPasswordActions.request),
              payload: values,
            });
            history.push('/login');
          }}
        >
          {(props) => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleSubmit,
              handleBlur,
            } = props;
            return (
              <Styles.StyledForm onSubmit={handleSubmit} noValidate>
                <Styles.StyledCardContent>
                  <Typography variant='h6'>Forgot password</Typography>
                  <Typography variant='caption'>
                    Enter your email address and we will send you a link to
                    reset your password.
                  </Typography>
                  <Grid container>
                    <Grid item xs={12}>
                      <Styles.StyledTextField
                        id='email'
                        margin='normal'
                        required
                        fullWidth
                        value={values.email}
                        label='Email address'
                        name='email'
                        autoComplete='email'
                        autoFocus
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(errors.email) && touched.email}
                        helperText={
                          errors.email && touched.email && errors.email
                        }
                        data-cy='forgotPassword_email'
                      />
                    </Grid>
                  </Grid>
                </Styles.StyledCardContent>

                <CardActions>
                  <Grid container alignItems='flex-end' justify='flex-end'>
                    <Button
                      className='orangeLink'
                      disabled={isSubmitting}
                      onClick={onCancel}
                      data-cy='cancel'
                    >
                      CANCEL
                    </Button>

                    <Button
                      color='secondary'
                      disabled={isSubmitting}
                      type='submit'
                      data-cy='sendResetLink'
                    >
                      SEND RESET LINK
                    </Button>
                  </Grid>
                </CardActions>
              </Styles.StyledForm>
            );
          }}
        </Formik>
      </ResponsiveCard>
    </CenterAlign>
  );
};

export default ForgotPassword;
